import { Menu } from 'src/design/molecules/Menu';
import { IconBrain, IconMessagePlus, IconSettings } from '@tabler/icons-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MEMORY_PROFILE_PATH } from 'src/app/chat/memoryNotes';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';

export interface IChatMemoryMenuProps {
  onNewChatWithoutMemory: () => void;
  /** Runs before navigating to the profile memory section, e.g. to close the drawer. */
  onManageMemory?: () => void;
}

/** @registry Memory menu in the chat drawer header: start a chat that neither reads nor saves memory notes, or open the profile memory section. */
export const ChatMemoryMenu: React.FC<IChatMemoryMenuProps> = ({
  onNewChatWithoutMemory,
  onManageMemory,
}) => {
  const navigate = useNavigate();
  return (
    <Menu position="bottom-start" withinPortal>
      <Menu.Target>
        <BasicActionIcon variant="subtle" label="Memory">
          <IconBrain size={18} />
        </BasicActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconMessagePlus size={16} />}
          onClick={onNewChatWithoutMemory}
        >
          New chat without memory
        </Menu.Item>
        <Menu.Item
          leftSection={<IconSettings size={16} />}
          onClick={() => {
            onManageMemory?.();
            navigate(MEMORY_PROFILE_PATH);
          }}
        >
          Manage memory
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
